import type { Rule } from 'antd/es/form';

export const KATAKANA_REGEX = /^[\u30A0-\u30FF\u31F0-\u31FF\uFF66-\uFF9Fー－ｰ･・\s]+$/u;

export const PHONE_NUMBER_REGEX = /^(?=(?:.*[0-9０-９]){10,})[0-9０-９+\-()（）\s]+$/u;

export const POSTAL_CODE_REGEX = /^[0-9０-９]{3}[-－]?[0-9０-９]{4}$/u;

export const katakanaRule = (
  message = 'カタカナ（全角）で入力してください',
): Rule => ({
  pattern: KATAKANA_REGEX,
  message,
});

export const phoneNumberRule = (
  message = '数字・ハイフン・カッコ（+記号を含む）のみで10桁以上入力してください',
): Rule => ({
  pattern: PHONE_NUMBER_REGEX,
  message,
});

export const postalCodeRule = (
  message = '数字7桁（例: 123-4567）で入力してください',
): Rule => ({
  pattern: POSTAL_CODE_REGEX,
  message,
});
